import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./country_code.js";
import "./country_subdivision.js";
import "./currency.js";
import "./timezone.js";
//#region src/country_code_helper.ts
var country_code_helper_exports = /* @__PURE__ */ __exportAll({
	getAvailableSubdivisions: () => getAvailableSubdivisions,
	getAvailableTimezones: () => getAvailableTimezones,
	getCurrency: () => getCurrency,
	getLocale: () => getLocale,
	name: () => name,
	usesVatPricingByDefault: () => usesVatPricingByDefault
});
function name(countryCode) {
	switch (countryCode) {
		case "US": return "USA";
		case "CA": return "Canada";
		case "DE": return "Germany";
		case "GB": return "UK";
	}
}
function getCurrency(countryCode) {
	switch (countryCode) {
		case "US": return "USD";
		case "CA": return "CAD";
		case "DE": return "EUR";
		case "GB": return "GBP";
	}
}
function getLocale(countryCode) {
	switch (countryCode) {
		case "US": return "en-US";
		case "CA": return "en-CA";
		case "DE": return "de-DE";
		case "GB": return "en-GB";
	}
}
function getAvailableTimezones(countryCode) {
	switch (countryCode) {
		case "CA": return [
			"America/Edmonton",
			"America/Halifax",
			"America/Regina",
			"America/Toronto",
			"America/St_Johns",
			"America/Vancouver",
			"America/Whitehorse",
			"America/Winnipeg"
		];
		case "DE": return ["Europe/Berlin"];
		case "GB": return ["Europe/London"];
		case "US": return [
			"America/Adak",
			"America/Anchorage",
			"America/Boise",
			"America/Chicago",
			"America/Denver",
			"America/Detroit",
			"America/Indiana/Indianapolis",
			"America/Indiana/Marengo",
			"America/Indiana/Knox",
			"America/Indiana/Petersburg",
			"America/Indiana/Tell_City",
			"America/Indiana/Vevay",
			"America/Indiana/Vincennes",
			"America/Indiana/Winamac",
			"America/Kentucky/Louisville",
			"America/Kentucky/Monticello",
			"America/Juneau",
			"America/Los_Angeles",
			"America/Menominee",
			"America/Metlakatla",
			"America/New_York",
			"America/Nome",
			"America/North_Dakota/Beulah",
			"America/North_Dakota/Center",
			"America/North_Dakota/New_Salem",
			"America/Phoenix",
			"America/Puerto_Rico",
			"America/Sitka",
			"America/Yakutat",
			"Pacific/Honolulu"
		];
	}
}
function getAvailableSubdivisions(countryCode) {
	switch (countryCode) {
		case "US": return [
			"AL",
			"AK",
			"AZ",
			"AR",
			"CA",
			"CO",
			"CT",
			"DE",
			"FL",
			"GA",
			"HI",
			"ID",
			"IL",
			"IN",
			"IA",
			"KS",
			"KY",
			"LA",
			"ME",
			"MD",
			"MA",
			"MI",
			"MN",
			"MS",
			"MO",
			"MT",
			"NE",
			"NV",
			"NH",
			"NJ",
			"NM",
			"NY",
			"NC",
			"ND",
			"OH",
			"OK",
			"OR",
			"PA",
			"RI",
			"SC",
			"SD",
			"TN",
			"TX",
			"UT",
			"VT",
			"VA",
			"WA",
			"WV",
			"WI",
			"WY",
			"DC",
			"AS",
			"GU",
			"MP",
			"PR",
			"VI"
		];
		case "CA": return [
			"AB",
			"BC",
			"MB",
			"NB",
			"NL",
			"NS",
			"ON",
			"PE",
			"QC",
			"SK",
			"NT",
			"NU",
			"YT"
		];
		case "DE":
		case "GB": return [];
	}
}
function usesVatPricingByDefault(countryCode) {
	switch (countryCode) {
		case "US":
		case "CA": return false;
		case "DE":
		case "GB": return true;
	}
}
//#endregion
export { country_code_helper_exports, getAvailableSubdivisions, getAvailableTimezones, getCurrency, getLocale, name, usesVatPricingByDefault };

//# sourceMappingURL=country_code_helper.js.map